import * as React from 'react';
import { createSvgIcon } from '@mui/material';

export const ReferenceNode = createSvgIcon(
  <svg width="24" height="24">
    <path d="M20.94 9.984v5.132a2.977 2.977 0 11-1.986 0v-3.148H13l.001 3.148a2.98 2.98 0 011.979 2.632l.005.175a2.977 2.977 0 11-3.97-2.808v-3.147H5.062v3.148a2.98 2.98 0 011.98 2.632l.005.175a2.977 2.977 0 11-3.97-2.808V9.984h7.94V7.829a2.978 2.978 0 01-1.98-2.633l-.006-.175A2.977 2.977 0 1113 7.83v2.155z" />
  </svg>,
  'ReferenceNode'
);
